import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DuplicatePreviewItemCustomField from './PreviewItemCustomField';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicatePreviewItemCustomFields = ({ customFields, file }) => {
  if (!file.custom_fields || file.custom_fields.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      {customFields.map(customField => (
        <DuplicatePreviewItemCustomField
          key={`custom-field-${customField.id}`}
          customField={file.custom_fields.find(cf => (cf.id === customField.id))}
        />
      ))}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  customFields: state.Metadata.customFields,
});

DuplicatePreviewItemCustomFields.propTypes = {
  customFields: PropTypes.array.isRequired,
  file: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(DuplicatePreviewItemCustomFields);
